// Store de ranking - top players por RankingScore (sistema ELO trucoxp).
// Sem polling: refresh manual ou em onMount da aba.
import { writable } from 'svelte/store';
import { api } from '../lib/api';
import type { ApiError } from '../lib/api';

export type RankingEntry = {
  id: string;
  nickname: string;
  score: number;
  avatar?: string;
};

export const ranking = writable<RankingEntry[]>([]);
export const rankingLoading = writable(false);
export const rankingError = writable<string | null>(null);

export async function loadRanking(limit = 100): Promise<void> {
  rankingLoading.set(true);
  rankingError.set(null);
  try {
    const data = await api.get<{ ranking: RankingEntry[] }>(`/ranking?limit=${limit}`);
    ranking.set(data.ranking ?? []);
  } catch (e) {
    const err = e as ApiError | Error;
    rankingError.set(err.message ?? 'erro ao carregar ranking');
  } finally {
    rankingLoading.set(false);
  }
}
